<template>
  <div class="follow">
    <CubePage type="myorder-view" title="天降红包" :isback="false">
      <div slot="content" class="content">
        <div class="hbbox" v-if=" retData.length == 0 || retData.total == 0">
          <van-empty class="custom-image" description="领取结束">
            <template #image>
              <img src="@/assets/img/empty.png" alt>
            </template>
          </van-empty>

          <van-button round plain hairline color="#ff6034" @click="cancelHb">个人中心</van-button>
        </div>
        <div v-else class="hbbox">
          <div class="dioconten" style="margin: 0px 3em">
            <img class="img" :src="retData.img">
            <div class="tips">
              恭喜获得幸运红包 *
              <span>{{retData.total}}</span>，核销完成后自动发放至钱包，是否领取？
            </div>
          </div>
          <div class="btns">
            <van-button round plain hairline color="#ff6034" type="warning" @click="cancelHb">个人中心</van-button>
            <van-button
              round
              color="linear-gradient(to right, #ff6034, #ee0a24)"
              @click="onLqHb"
            >红包领取</van-button>
          </div>
        </div>
      </div>
    </CubePage>
    <!-- 红包插件 -->
    <van-dialog
      v-if="retData != null && retData.total > 0"
      v-model="show"
      title="天降红包"
      show-cancel-button
      confirmButtonText="领取"
      @confirm="confirmHb"
      @cancel="cancelHb"
    >
      <div class="dioconten">
        <img class="img" :src="retData.img">
        <div class="tips">
          恭喜获得幸运红包 *
          <span>{{retData.total}}</span>，是否领取？
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import CubePage from "../TP/cube-page.vue";
import * as util from "@/utils/network";
import wx from "weixin-js-sdk";
import { Dialog } from "vant";
export default {
  components: {
    CubePage
  },
  data() {
    return {
      show: false,
      retData: null
    };
  },
  created() {
    this.getData();
  },
  methods: {
    onLqHb() {
      Dialog.confirm({
        title: "天降红包",
        message: "恭喜获得幸运红包 *" + this.retData.total + "是否领取？"
      })
        .then(() => {
          this.confirmHb();
        })
        .catch(() => {
          // on cancel
        });
    },
    confirmHb() {
      var url = "/addons/litestore/api.reward/receive";
      let that = this;
      var params = {
        order_id: this.$route.query.order_id,
        role: this.$route.query.role,
        did: this.$route.query.did
      };
      //这里直接调用网络接口
      util.post(url, params, function(result) {
        console.log("object", result);
        if (result.code == 1) {
          Dialog.alert({
            message: result.msg,
            confirmButtonText: "确定"
          })
            .then(() => {
              that.$router.push({
                path: "/hbList"
              });
            })
            .catch(() => {
              // on cancel
            });
        }
      });
    },
    cancelHb() {
      this.$router.push({
        path: "/my"
      });
    },
    getData() {
      var url = "/addons/litestore/api.reward/getOfferActivity";
      let that = this;
      var params = {
        order_id: this.$route.query.order_id,
        role: this.$route.query.role
      };
      //这里直接调用网络接口
      util.post(url, params, function(result) {
        console.log("object", result);
        if (result.data) {
          //   that.show = result.data.total > 0 ? true : false;
          that.retData = result.data;
          console.log(that.retData);
        }
      });
    }
  }
};
</script>
<style lang="less" scoped="scoped">
/deep/ .cube-page > .wrapper {
  background-color: #fff;
}

.content {
  padding: 10px;
  box-sizing: border-box;
  color: #fff;
}
/deep/ .van-dialog__header {
  padding: 0;
  line-height: 55px;
  background-color: antiquewhite;
}
.dioconten,
.hbbox {
  padding-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .tips {
    padding: 10px 0;
    color: red;
  }
}
.img {
  height: 450px;
}
.btns {
  width: 70%;
  display: flex;
  justify-content: space-between;
}
</style>
